import { SidebarService } from './../sidebar/sidebar.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { LinkComponent } from './link/link.component';
import { VersionService } from '../../../shared/services/version.service';
import { HasRoleDirective } from '../../directives/has-role.directive';
import { environment } from '@src/environments/environment';
import { BranchPipe } from '../../pipes/branch.pipe';
import { adminAccess } from '@src/app/core/lists/AdminAccessRoles';
import { MatTooltip } from '@angular/material/tooltip';
import { AuthService } from '@src/app/features/auth/auth.service';
import { CashService } from '../../../features/cash/cash.service';
import { IconComponent } from '../icon/icon.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'Menu',
  standalone: true,
  imports: [
    CommonModule,
    LinkComponent,
    HasRoleDirective,
    BranchPipe,
    MatTooltip,
    IconComponent,
    RouterModule,
  ],
  templateUrl: './menu.component.html',
})
export class MenuComponent implements OnInit {
  cx = '-';

  adminAccess = adminAccess;

  envMode = environment.mode;

  nameBranch!: string;

  menuCountData: any = [];

  // Controle dos dropdowns
  dropdowns = {
    entradas: false,
    patio: false,
  };

  constructor(
    private sidebarService: SidebarService,
    public versionService: VersionService,
    public authService: AuthService,
    public cashService: CashService,
  ) {}

  ngOnInit() {
    this.updateCx();
    this.nameBranch = this.authService.branch.name;

    setInterval(() => {
      this.updateCx();
    }, 200);

    const interval = setInterval(() => {
      const data = localStorage.getItem('countDataMenu');

      if (data) {
        this.menuCountData = JSON.parse(data);
        clearInterval(interval);
      }
    }, 200);

    // Fecha dropdowns ao clicar fora
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.relative')) {
        this.closeAllDropdowns();
      }
    });
  }

  updateCx() {
    this.cx = this.cashService.cash?.opening?.sequencial_number ?? '-';
  }

  openSidebar() {
    this.sidebarService.emitOpen();
  }

  toggleDropdown(dropdown: 'entradas' | 'patio') {
    // Fecha outros dropdowns
    Object.keys(this.dropdowns).forEach((key) => {
      if (key !== dropdown) {
        this.dropdowns[key as keyof typeof this.dropdowns] = false;
      }
    });
    // Toggle o dropdown atual
    this.dropdowns[dropdown] = !this.dropdowns[dropdown];
  }

  closeAllDropdowns() {
    Object.keys(this.dropdowns).forEach((key) => {
      this.dropdowns[key as keyof typeof this.dropdowns] = false;
    });
  }
}
